import { AppointmentsAvailableTimesDatasource } from './appointments_available_times_datasource';
import { AppointmentsLocationsDatasource } from './appointments_locations_datasource';
import { CancellationReasonsDatasource } from './cancellation_reasons_datasource';
import { UpcomingAppointmentsDatasource } from './upcoming_appointments_datasource';

angular
  .module('capability-ng-appointments')
  .service('ngUpcomingAppointmentsDatasource', UpcomingAppointmentsDatasource)
  .service('ngCancellationReasonsDatasource', CancellationReasonsDatasource)
  .service('ngAppointmentsLocationsDatasource', AppointmentsLocationsDatasource)
  .service('ngAppointmentsAvailableTimesDatasource', AppointmentsAvailableTimesDatasource);

export * from './appointments_available_times_datasource';
export * from './appointments_locations_datasource';
export * from './cancellation_reasons_datasource';
export * from './upcoming_appointments_datasource';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/datasources/datasources_module.ts